const root = document.documentElement;

let mediaQuery;
let systemListener;

export function setDarkMode(enabled) {
  root.classList.toggle("dark", enabled);
}

export function syncWithSystem() {
  mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
  setDarkMode(mediaQuery.matches);

  if (systemListener) mediaQuery.removeEventListener("change", systemListener);
  systemListener = (event) => setDarkMode(event.matches);
  mediaQuery.addEventListener("change", systemListener);
}

export function stopSyncWithSystem() {
  if (mediaQuery && systemListener) {
    mediaQuery.removeEventListener("change", systemListener);
  }
  mediaQuery = undefined;
  systemListener = undefined;
}

export function getStoredThemePreference() {
  try {
    return localStorage.getItem("theme"); // "light" | "dark" | "system"
  } catch {
    return null;
  }
}

export function setStoredThemePreference(theme) {
  try {
    localStorage.setItem("theme", theme);
  } catch {
    // ignore
  }
}

export function applyThemePreference(theme) {
  if (theme === "system") {
    syncWithSystem();
    return;
  }

  stopSyncWithSystem();
  setDarkMode(theme === "dark");
}

export function initTheme() {
  const pref = getStoredThemePreference() || "system";
  applyThemePreference(pref);
}